import React from 'react';
import { Link } from 'react-router-dom';

export const Header = () => {

  return (
    <React.Fragment>
      {/* Mobile Navigation */}
      <div className="metaportal_fn_mobnav">
        <div className="mob_top">
          <div className="logo">
            <Link to="/"><img src="/img/logo.png" alt="" width="250" height="75" /></Link>
          </div>
          <div className="logo">
            <Link to="/"><img src="/img/logo4MN.png" alt="" width="250" height="75" /></Link>
          </div>
        </div>
      </div>
      {/* !Mobile Navigation */}

      {/* Header */}
      <header id="header">
        <div className="header">
          <div className="header_in">

            <div className="trigger_logo">
              {/* <div className="trigger">
                <span></span>
              </div> */}
              <div className="logo">
                <Link to="/"><img src="/img/logo.png" alt="" width="300" height="90" /></Link>
              </div>
            </div>

            <div className="nav">
              {/* <ul>
                <li><a className="creative_link" href="#home">Home</a></li>
                <li><a className="creative_link" href="#about">About</a></li>
                <li><a className="creative_link" href="#collection">Collection</a></li>
                <li><a className="creative_link" href="#news">Blog</a></li>
                <li><a className="creative_link" href="#contact">Contact</a></li>
              </ul> */}
            </div>

            <div className="logo">
              {/* <img src="/img/logo4MN.png" alt="" width="58" height="108" /> */}
              <img src="/img/logo4MN.png" alt=""  width="370" height="90" />
            </div>

          </div>
        </div>
      </header>
      {/* !Header */}
    </React.Fragment>
  )


}





